import React, { useContext, useEffect, useState } from "react";

import { Tabs, Tab, Box } from "@material-ui/core";
import ManageSignatureAccounts from "views/Dashboard/ManageSignatureAccounts/ManageSignatureAccounts";
import ThriveSignatureRequest from "views/Dashboard/ThriveSignatureRequest/ThriveSignatureRequest";
import SignatureAudit from 'views/Dashboard/SignatureAudit/SignatureAudit';
import SignatureEnrollments from "views/Dashboard/SignatureEnrollments/SignatureEnrollments";
import SignatureUnEnrollments from "views/Dashboard/SignatureUnEnrollments/SignatureUnEnrollments";
import UnlockShiptoManagement from "views/Dashboard/UnlockShiptoManagement/UnlockShiptoManagement";
import MilestoneTracking from "views/Dashboard/MilestoneTracking/MilestoneTracking";
import { useHistory, useLocation } from 'react-router-dom';





import Context from 'context/context';


 





export default function SignatureTab() {
  const [value, setValue] = useState(0);
  const { state, dispatch } = useContext(Context);
  const [allowedTabs, setAllowedTabs] = useState([]);
let disable=true
const location = useLocation();
const history = useHistory();
const params = new URLSearchParams(location.search);
const parentTab = parseInt(params.get('tab') || '0');
const childTab = parseInt(params.get('childTab') || '0');

const handleParentTabChange = (event, newValue) => {
  params.set('tab', newValue);
  params.set('childTab', '0'); // reset child
  history.replace({ search: params.toString() });
};

  const handleChange = (event, newValue) => {
    if(state?.userInfo?.loyalty_organization_name === 'Henry Schein Dental'){
    setValue(newValue);
    }else {
      
      newValue=newValue==1?2:newValue
  

    setValue(newValue);

    }
  };

  // Optional: Store components in an array to easily switch
  let components
const allComponents = [
  {
    path: "/dashboard/manage-signature-accounts-tab",
    label: "Manage Signature Accounts",
    element: <ManageSignatureAccounts />,
  },
  

  {
    path: "/dashboard/signature-enrollments",
    label: "Enrollments",
    element: <SignatureEnrollments />,
  },  
  {
    path: "/dashboard/signature-unenrollments",
    label: "Unenrollments",
    element: <SignatureUnEnrollments />,
  }, 

  // {
  //   path: "/dashboard/thrive-signature-request",
  //   label: "Thrive Signature Request",
  //   element: <ThriveSignatureRequest />,
  // },
  // {
  //   path: "/dashboard/audit-signature",
  //   label: "Audit Signature",
  //   element: <SignatureAudit />,
  // },

   {
      path: "/dashboard/manage-unlock-accounts",
      label: "Unlocked Eligibility Management",
      element: <UnlockShiptoManagement />,
    },

    // GROWTH BONUS TRACKER MAIN TAB
    {
      path: "/dashboard/unlock-milestone-tracking",
      label: "Growth Bonus Tracker",
      element: <MilestoneTracking/>
    },
 

];
useEffect(() => {
  if (state && state.userInfo && Object.keys(state.userInfo).length > 0) {
    if (
      state &&
      state.userInfo.allowedRoutes &&
      Object.keys(state.userInfo.allowedRoutes).length > 0
    ) {
      const allowed = allComponents.filter((comp) =>
      state.userInfo.allowedRoutes.some((api) => api.path
      === comp.path)
    );

    setAllowedTabs(allowed);

    }
  }
}, [state.userInfo]);

console.log(allowedTabs,"allowedTabs")
 


  return (
    <Box>
  
      <Tabs value={parentTab} onChange={handleParentTabChange}aria-label="Points Management Tabs"
      TabIndicatorProps={{
    style: { backgroundColor: '#007bff' }, // e.g., '#1976d2' for blue
  }}>
         {allowedTabs.map((tab, index) => (
          <Tab
            key={tab.path}
            label={tab.label}
            sx={{ textTransform: "none" }}
          />
        ))}

        

      </Tabs>
   

      <Box sx={{ p: 2 }}>
      {allowedTabs.length > 0 && allowedTabs[parentTab]?.element}
    </Box>
    </Box>
  );
}
